export const GET_LIST_OF_LANGUAGES = 'GET_LIST_OF_LANGUAGES';
export const GET_LIST_OF_LANGUAGES_SUCCESS = 'GET_LIST_OF_LANGUAGES_SUCCESS';

export const getListOfLangAction = () => ({
  type: GET_LIST_OF_LANGUAGES,
});